@if (!item.hidden) {
  <!-- item with router url -->
  @if (item.url && !item.externalUrl) {
    <a
      class="d-flex align-items-center"
      [ngClass]="item.classes"
      [routerLink]="[item.url]"
      [target]="item.openInNewTab ? '_blank' : '_self'"
      [title]="item.title">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item with external url -->
  @if (item.url && item.externalUrl) {
    <a
      class="d-flex align-items-center"
      [ngClass]="item.classes"
      [href]="item.url"
      [target]="item.openInNewTab ? '_blank' : '_self'">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <ng-template #itemContent>
    @if (item.icon) {
      <love-it-generic-icon [selector]="item.icon"></love-it-generic-icon>
    }
    <span
      class="menu-title text-truncate"
      [translate]="item.translate"
      >{{ item.title }}</span
    >
    @if (item.badge) {
      <span
        class="badge ms-auto me-1"
        [translate]="item.badge.translate"
        [ngClass]="item.badge.classes">
        {{ item.badge.title }}
      </span>
    }
  </ng-template>
}
